<template>
  <div>
    <div class="total_data" :class="[`img${currentIndex}`]">
    <!-- <br> -->
    <h2>{{ titleText }}</h2>
    <img class="line" src="../images/7.png">
  </div>
  <div class="day_week_m">
    <div v-for="(item, index) in tabList" :key="index" :class="[item.active ? 'active' : '']" @click="tabClick(index)">{{ item.name }}</div>
  </div>
  <div class="date-picker">
      <div class="date-group">
        <input type="date" class="date-input"
        v-model="selectedStartDate" />
        <div class="date-separator"></div>
        <input type="date" class="date-input" v-model="selectedEndDate" />
      </div>
      <div class="date-button1" @click="selectDates">确认</div>
    </div>
  </div>
</template>
<script>
import {shortcuts} from '../utils/index'
export default {
  props: ['currentIndex', 'titleText'],
  data() {
    return {
      tabList: [
        {name: '今天', active: false},
        {name: '近30天', active: true},
        {name: '近60天', active: false},
        {name: '近90天', active: false}
      ],
      selectedStartDate:"",
      selectedEndDate:"",
    }
  },
  mounted() {
    const dataList = shortcuts(1)
    this.selectedStartDate = `${dataList[0].getFullYear()}-${(dataList[0].getMonth() + 1) > 9 ? dataList[0].getMonth() + 1 : '0' + (dataList[0].getMonth() + 1)}-${dataList[0].getDate() > 9 ? dataList[0].getDate() : '0' + dataList[0].getDate()}`
    this.selectedEndDate = `${dataList[1].getFullYear()}-${(dataList[1].getMonth() + 1) > 9 ? dataList[1].getMonth() + 1 : '0' + (dataList[1].getMonth() + 1)}-${dataList[1].getDate() > 9 ? dataList[1].getDate() : '0' + dataList[1].getDate()}`
  },
  methods: {
    tabClick(index) {
      const newList = this.tabList.map((item, current) => {
        if (current === index) {
          item.active = true
        } else {
          item.active = false
        }
        return item
      })
      const dataList = shortcuts(index)
      this.selectedStartDate = `${dataList[0].getFullYear()}-${(dataList[0].getMonth() + 1) > 9 ? dataList[0].getMonth() + 1 : '0' + (dataList[0].getMonth() + 1)}-${dataList[0].getDate() > 9 ? dataList[0].getDate() : '0' + dataList[0].getDate()}`
      this.selectedEndDate = `${dataList[1].getFullYear()}-${(dataList[1].getMonth() + 1) > 9 ? dataList[1].getMonth() + 1 : '0' + (dataList[1].getMonth() + 1)}-${dataList[1].getDate() > 9 ? dataList[1].getDate() : '0' + dataList[1].getDate()}`
      this.tabList = newList
      this.selectDates()
    },
    
    selectDates() {
      // 处理日期选择逻辑
      // 获取选定的开始日期和结束日期：this.selectedStartDate 和 this.selectedEndDate
      this.$emit('onChangeTime', {
        current: this.$props.currentIndex,
        date: [
          new Date(this.selectedStartDate),
          new Date(this.selectedEndDate)
      ]
      })
    },
  }
}
</script>
<style lang="less" scoped>
  .total_data {
      width: 355px;
      margin-top: 10%;
      margin-left: -5%;
      .line {
        width: 400px;
        margin-left: -3%;
      }
      h2 {
        font-weight: normal;
        font-size: 18px;
        color: #737373;
        margin-left: 18px;
        padding-top: 20px; 
      }
  }



  .img1 {
    background: url('../images/data1.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    }
    .img2 {
    background: url('../images/pmz27.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    }
    .img3 {
    background: url('../images/pmz28.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    }
    .img4 {
    background: url('../images/pmz29.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    }
    .img5 {
    background: url('../images/pmz30.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    }
    .img6 {
    background: url('../images/pmz31.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    }
    .img7 {
    background: url('../images/pmz32.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    }
  .day_week_m {
    display: flex;
    color: #737373;
    justify-content: space-around;
    padding: 12px 11px 12px 16px;
    .active {
      color: #737373;
      border-bottom: 2px solid #52b896;
      padding-bottom: 21px;
    }
  }
  .date-picker {
    display: flex;
    align-items: center;
    padding: 0 12px;
    .date-group {
      display: flex;
      align-items: center;
      margin-right: 8px;
      .date-input {
        width: 120px;
        height: 36px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #cfcfcf;
        font-size: 14px;
        font-weight: 400;
        color: #737373;
        background-color: rgba(255,255,255,0);
        position: relative;
      }
      input[type="date"]::-webkit-datetime-edit {
          padding-left: 28px;
      }
      input[type="date"]::-webkit-calendar-picker-indicator {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 10px;
        background: url('../images/date-input.png') no-repeat center center;
        background-size: 12px 12px;
      }
      .date-separator {
        width: 8px;
        height: 1px;
        background: #737373;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin: 0 6px;
      }
    }
    .date-button1 {
      width: 60px;
      height: 36px;
      background: #52b896;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
    }
  }
</style>